import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/navigation/ScrollToTop";
import HomePage from "./pages/HomePage";
import UseCasesPage from "./pages/UseCasesPage";
import CustomSolutionsPage from "./pages/CustomSolutionsPage";
import IndustriesPage from "./pages/IndustriesPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () =>
<QueryClientProvider client={queryClient} data-id="pp9zdjmp3" data-path="src/App.tsx">
    <TooltipProvider data-id="e62ae5f2b" data-path="src/App.tsx">
      <Toaster data-id="ba32vzik8" data-path="src/App.tsx" />
      <BrowserRouter data-id="52reylf1p" data-path="src/App.tsx">
        <ScrollToTop behavior="instant" data-id="lqinm5ucx" data-path="src/App.tsx" />
        <Routes data-id="2i2asaggs" data-path="src/App.tsx">
          <Route path="/" element={<HomePage data-id="2u7lwux7r" data-path="src/App.tsx" />} data-id="jqsizoios" data-path="src/App.tsx" />
          <Route path="/about" element={<AboutPage data-id="t0oc68awj" data-path="src/App.tsx" />} data-id="evp4fls3o" data-path="src/App.tsx" />
          <Route path="/use-cases" element={<UseCasesPage data-id="z4knz71ew" data-path="src/App.tsx" />} data-id="nd6cz15ic" data-path="src/App.tsx" />
          <Route path="/custom-solutions" element={<CustomSolutionsPage data-id="4154resg1" data-path="src/App.tsx" />} data-id="wepi5m082" data-path="src/App.tsx" />
          <Route path="/industries" element={<IndustriesPage data-id="u7vc98hxh" data-path="src/App.tsx" />} data-id="njixxch9j" data-path="src/App.tsx" />
          <Route path="/case-studies" element={<CaseStudiesPage data-id="8b8kfha7q" data-path="src/App.tsx" />} data-id="swt2xb6qm" data-path="src/App.tsx" />
          <Route path="/contact" element={<ContactPage data-id="mqie19dpq" data-path="src/App.tsx" />} data-id="dtf4t5fc6" data-path="src/App.tsx" />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound data-id="hjnoxb23l" data-path="src/App.tsx" />} data-id="zo33mtg33" data-path="src/App.tsx" />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>;


export default App;